<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الفصل-الأول">
<h1 style="padding-top:220px;"><span dir="rtl">الفصل</span> <span dir="rtl">الأول</span></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?26b88940